import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

import { apiHost } from '../../../config';
import downloadFile from '../../../lib/downloadFile';
import uploadFile from '../../../lib/uploadFile';
import handleApiErrors from '../../../lib/apiClient/handleErrors';

import AddCard from '../../../components/common/AddCard/Card';
import ExcelFileCard from '../../../components/common/ExcelFileCard/Card';
import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';
import PdfFileCard from '../../../components/common/PdfFileCard/Card';

interface ImportsPageProps {
  showError: (text: string) => void;
  unauthorizedCallback: () => void;
}

const ImportsPage = ({ showError, unauthorizedCallback }: ImportsPageProps) => {
  const [waiting, setWaiting] = useState(false);

  const downloadInstructions = () => {
    if (waiting) return;
    setWaiting(true);

    handleApiErrors(
      downloadFile(`${apiHost}/pdf/instructions`, 'Методические рекомендации.pdf')
        .then(() => setWaiting(false))
        .catch(() => {
          setWaiting(false);
          showError('Ошибка на сервере');
        }),
      unauthorizedCallback,
      showError,
    );
  };

  const downloadImportTemplate = () => {
    if (waiting) return;
    setWaiting(true);

    handleApiErrors(
      downloadFile(
        `${apiHost}/xlsx/import_template`,
        'Шаблон загрузки учеников.xlsx',
      )
        .then(() => setWaiting(false))
        .catch(() => {
          setWaiting(false);
          showError('Ошибка на сервере');
        }),
      unauthorizedCallback,
      showError,
    );
  };

  const exportStudents = () => {
    if (waiting) return;
    setWaiting(true);

    handleApiErrors(
      downloadFile(`${apiHost}/api/teacher/users/xlsx`, 'Ученики.xlsx')
        .then(() => setWaiting(false))
        .catch(() => {
          setWaiting(false);
          showError('Ошибка на сервере');
        }),
      unauthorizedCallback,
      showError,
    );
  };

  const uploadStudents = () => {
    if (waiting) return;
    setWaiting(true);

    uploadFile(
      `${apiHost}/api/teacher/users/xlsx`,
      'students',
      'students.xlsx',
      '.xlsx',
    )
      .then(() => {
        setWaiting(false);
        alert('Ученики успешно загружены');
      })
      .catch(({ message }) => {
        setWaiting(false);

        if (message === 'Unauthorized' || message === 'Forbidden') {
          unauthorizedCallback();
        } else {
          showError(message);
        }
      });
  };

  return (
    <>
      {waiting && (
        <Spinner
          animation="border"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 80,
            height: 80,
            marginTop: '-40px',
            marginLeft: '-40px',
          }}
        >
          <span className="visually-hidden">Импорт учеников...</span>
        </Spinner>
      )}
      <div style={{ width: '720px' }}>
        <section>
          <div className="d-flex justify-content-between align-items-center gap-4 mb-5">
            <h4>Импорт</h4>
            <hr className="flex-grow-1" />
          </div>

          <div className="d-flex gap-5 mb-5">
            <AddCard onClick={uploadStudents} />
            <ExcelFileCard
              filename="Шаблон.xlsx"
              download={downloadImportTemplate}
            />
            <PdfFileCard
              filename="Рекомендации.pdf"
              download={downloadInstructions}
            />
          </div>
        </section>

        <section>
          <div className="d-flex justify-content-between align-items-center gap-4 mb-5">
            <h4>Экспорт</h4>
            <hr className="flex-grow-1" />
          </div>

          <ExcelFileCard filename="Ученики.xlsx" download={exportStudents} />
        </section>
      </div>
    </>
  );
};

export default withPopupErrors<ImportsPageProps>(ImportsPage);
